import moment from "moment";
import api from "./Api";
import { handleApiError } from "../utils/apiUtils";

const DashBoard = process.env.REACT_APP_DASHBOARD_URL || "";
const TranscriberAPI = api(DashBoard);

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

export const getTranscriberRushNotesSummary = async (
  limit: any,
): Promise<any> => {
  try {
    const response = await TranscriberAPI.get<ApiResponse<any>>(
      `/api/transcriber/dashboard/latestrush-notes?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getTranscriberCaseActionsSummary = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await TranscriberAPI.get(
      `/api/transcriber/dashboard/case-actions?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const fetchTransciberStatusPipeline = async (interval: any) => {
  try {
    const response = await TranscriberAPI.get(
      `/api/transcriber/dashboard/status-summary?interval=${interval}`,
    );
    return response.data ?? [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getTranscriberInvoiceOverview = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await TranscriberAPI.get(
      `/api/transcriber/dashboard/invoice-overview?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getTranscriberDoctorWise = async (
  limit: any,
  interval: any,
): Promise<any[]> => {
  try {
    const response = await TranscriberAPI.get(
      `api/transcriber/dashboard/doctorwise-status?topN=${limit}&interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};
export const getTranscriberWorkbreakdown = async (
  qmeDoctorUserId: any,
  interval: any,
): Promise<any[]> => {
  try {
    const response = await TranscriberAPI.get(
      `api/transcriber/dashboard/workload-breakdown?qmeDoctorUserId=${qmeDoctorUserId}&interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getTranscriberToDO = async (limit: any): Promise<any> => {
  try {
    const response = await TranscriberAPI.get<ApiResponse<any>>(
      `/api/transcriber/dashboard/to-do?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
